import axios from 'axios'

export default {
  getOrganizationDict() {
    return axios.get('/api/dicts/organizations')
  },
  getRoles() {
    return axios.get('/api/dicts/roles')
  },
  getOlympicsDict() {
    return axios.get('/api/dicts/olympics')
  },
  getLink() {
    return axios.get('/api/dicts/app-link')
  },
  getExpertExampleFile() {
    return axios.get('/api/dicts/expert-file')
  },
  getCurrentTime() {
    return axios.get('/api/dicts/current-time')
  }
}
